import React from 'react'
import { MenuHeaderContext } from '../../menu/menu-context'
import './card-header.scss'

// actions: buttons the card's list offers (a node, e.g. Download), in the
// header beside its menu -- never inside it (owner 2026-10-23: a list's
// actions are visible buttons in its card's header).
// asStored: a person's name or other text that is shown as it was written.
// An email address is shown exactly as stored: capitalising it ("Scim.test@Heizenrader.com") changes an address people copy.
const isEmail = title => typeof title === 'string' && /\S@\S/.test(title)

export const CardHeader = ({ title, subtitle, HeaderComponent, HeaderMenu, actions, asStored }) => {
  return (
    <React.Fragment>
      {/* flex-nowrap, not flex-wrap: the actions are anchored to the top-right and
          must stay there. With wrapping, a long title pushed the kebab onto its own
          line below the heading, and the dropdown then resolved against a box at the
          far left of the card and opened off the left edge of the screen.

          The title cell needs minWidth 0 to make that hold. A flex item defaults to
          min-width:auto, meaning it refuses to shrink below its content — so a long
          title grows the cell, and with nowrap it would push the actions off-screen
          instead of wrapping. Setting it to 0 lets the cell shrink and the text wrap
          inside its own column, always to the LEFT of the buttons.

          overflowWrap breaks a single unbroken token (a long slug or URL) rather than
          letting it overflow the cell and collide with the actions. */}
      <div className={`d-flex flex-row flex-nowrap align-items-start gap-2 ${title && 'border-bottom'}`}>
        <div className="card-title flex-grow-1" style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
          {title &&
            <h4 className={asStored || isEmail(title) ? undefined : 'text-capitalize'}>
              {title}
            </h4>}
        </div>
        <div className="card-title flex-shrink-0">
          {HeaderComponent && <HeaderComponent />}
          {actions && <div className="card-header-actions" data-testid="card-header-actions">{actions}</div>}
        </div>
        <div className="card-title flex-shrink-0 ms-auto">
          {HeaderMenu &&
            <MenuHeaderContext.Provider value={true}>
              <HeaderMenu />
            </MenuHeaderContext.Provider>}
        </div>
      </div>

      {subtitle &&
        <h6 className="card-subtitle m-2 text-body-secondary">
          {subtitle}
        </h6>}

      {/* {(title || HeaderComponent || HeaderMenu) &&
        <div className="border-bottom" onClick={onClick}>
          <div className="d-flex flex-row flex-wrap">
            {title &&
              <div className="card-title flex-fill">
                <h4 className="text-capitalize">
                  {title}
                </h4>
              </div>}
            {HeaderComponent &&
              <div className="card-title">
                <HeaderComponent />
              </div>}
            {HeaderMenu &&
              <div className="card-title">
                <HeaderMenu />
              </div>}
          </div>

          {subtitle &&
            <h6 className="card-subtitle mb-2 text-body-secondary">
              {subtitle}
            </h6>}
        </div>} */}
    </React.Fragment>
  )
}
